<ax-text-area [(text)]="value" [rows]="rows"  *ngIf="visible" [placeholder]="placeholder" [readonly]="readonly"> 
</ax-text-area>